import { Box, Divider, StyledLink } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import Placeholder from "src/components/OptionBadge/sub-components/Placeholder";
import TagListItem from "src/components/Team/TagListItem";
import { OptionValuePropType } from "src/custom-prop-types/search";
import { trackEvent } from "src/services/segment";
import { trackExploreJourneyEvent } from "src/services/exploreOrganisationAnalytics";
import { useHeaderSearchRecentsContext } from "src/components/Search/headerSearch/HeaderSearchRecentsContext";
import { viewedFromLabel } from "src/components/Search/headerSearch/headerSearchRecentEntries";
import { rememberHeaderSearchHit } from "src/components/Search/headerSearch/headerSearchRecorder";
import { EVENT_TRACKING } from "src/consts/eventTracking";

const OptionTagBadge = ({ data, isLoading, selectedString }) => {
  const headerSearch = useHeaderSearchRecentsContext();

  if (isLoading) {
    return (
      <>
        <Box px="s" py="s">
          <Placeholder />
        </Box>
        <Divider light />
      </>
    );
  }

  const { tag, link } = data;

  return (
    <StyledLink
      data-testid="cp-option-link"
      to={link}
      onClick={() => {
        // LEGACY until 2026-11-17
        trackEvent(EVENT_TRACKING.TAG_CLICKED, {
          action: "tag_styled_link_selected",
        });
        trackExploreJourneyEvent(EVENT_TRACKING.TAG_NAVIGATION_COMPLETED, {
          lifecycle_stage: "completed",
          entry_point: "global_search",
          operation_intent: "search",
          result_type: "tag",
        });
        rememberHeaderSearchHit(headerSearch, {
          query: selectedString || tag?.displayValue || "",
          kind: "tag",
          viewed: viewedFromLabel(
            "tag",
            tag?.id,
            tag?.displayValue || selectedString || ""
          ),
        });
      }}
      display="block"
      width="100%"
    >
      <Box px="s">
        <TagListItem
          isLastItem={data.customStyles}
          tag={tag}
          loading={isLoading}
          selectedString={selectedString}
        />
      </Box>
    </StyledLink>
  );
};

OptionTagBadge.propTypes = {
  data: OptionValuePropType,
  isLoading: PropTypes.bool,
  selectedString: PropTypes.string,
};

export default OptionTagBadge;
